import cssContent from './iframe.css';
import cssEmailAgentContent from './iframe_email_agent.css';
import cssEmailAgentInlineContent from './iframe_email_agent_inline.css';
import cssGlobalContent from './iframe_global.css';
import { minifyCss } from './minifyCss';

export const postCss = () => {
  const minifiedCss = minifyCss(cssContent);
  window.parent.postMessage({ message: 'custom css', cssContent: minifiedCss }, '*');

  const minifiedGlobalCss = minifyCss(cssGlobalContent);
  window.parent.postMessage({ message: 'custom global css', cssContent: minifiedGlobalCss }, '*');
};

export const postEmailAgentCss = () => {
  const minifiedEmailAgentCss = minifyCss(cssEmailAgentContent);
  window.parent.postMessage({ message: 'custom email agent css', cssContent: minifiedEmailAgentCss }, '*');
};

export const postEmailAgentInlineCss = () => {
  const minifiedEmailAgentInlineCss = minifyCss(cssEmailAgentInlineContent);
  window.parent.postMessage({ message: 'custom email agent inline css', cssContent: minifiedEmailAgentInlineCss }, '*');
};
